//Change active menu on Scroll Tags Columns Block
$("ul.skiplink li a").on("click", function (event) {
    $("ul.skiplink li a").removeClass("active");
    $(this).addClass("active");
});

$(window).on("scroll", function () {
    $("ul.skiplink-content li").each(function () {
        if ($(window).scrollTop() >= $(this).offset().top) {
            var id = $(this).attr("id");
            $("ul.skiplink li a").removeClass("active");
            $("ul.skiplink li a[href=#" + id + "]")
                .addClass("active");
        }
    });
});
